import { FeatureFlagsActionKind } from './reducer';
export const featureFlagsReducer = (state, action) => {
    switch (action.type) {
        case FeatureFlagsActionKind.GetFeatureFlagsSettings: {
            return {
                ...action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
